import { Box } from '@madeiramadeirabr/layout-web';
import { cva } from '@madeiramadeirabr/styled-system/css';
import { styled } from '@madeiramadeirabr/styled-system/jsx';

export const BreadcrumbContainerStyle = cva({
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '$small',

    '& ul': {
      py: '$medium',

      '& li': {
        flex: 'none',
      },
    },

    '& a': {
      textDecoration: 'none',
    },

    $mdDown: {
      display: 'none',

      '& ul': {
        overflowX: 'scroll',
        scrollbarWidth: 'none',
        px: '$xsmall',

        '& li:last-child': {
          mr: '$small',
        },
      },
    },
  },
  variants: {
    hasItemBack: {
      true: {
        '& li:first-child a': {
          color: '$text-default',
        },
      },
    },
  },
});

export const BreadcrumbContainer = styled(Box, BreadcrumbContainerStyle);
